










































































































































































import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop} from 'vue-property-decorator';

import {Certificate} from '@fidm/x509';
import {Notify} from '@/utils/Notify';
import {FileStringReader} from '@/utils/FileReader';

import {
  ClientAuthenticationMethod,
  LoraForwarderBasicStationServerConfig,
} from '@/model/lora/BasicStation/LoraForwarderBasicStationServerConfig';

import {BaseComponent} from '@/mixins/BaseComponent';
import LoraForwarderControl from '@/components/Lora/Forwarder/LoraForwarderControl.vue';
import LoraForwarderConfiguration from '@/components/Lora/Forwarder/LoraForwarderConfiguration.vue';
import LoraForwarderConfigFileEditor from '@/components/Lora/Forwarder/LoraForwarderConfigFileEditor.vue';
import CertificateDetails from '@/components/Utils/CertificateDetails.vue';

@Component({
  components: {CertificateDetails, LoraForwarderControl, LoraForwarderConfiguration, LoraForwarderConfigFileEditor},
})
export default class LoraForwarderBasicStationServerSettings extends Mixins<BaseComponent>(BaseComponent) {

  private ClientAuthenticationMethod = ClientAuthenticationMethod;

  @Prop()
  private title!: string;

  @Prop()
  private description!: string;

  @Prop()
  private serverConfig!: LoraForwarderBasicStationServerConfig;

  private valid: boolean = false;

  private serverCertificateFile: File | null = null;

  private clientCertificateFile: File | null = null;

  private clientKeyFile: File | null = null;

  private showToken: boolean = false;

  private required(value: string) {
    return !this.serverConfig.enabled || !!value || 'Required';
  }

  get serverCertificate(): Certificate | null {

    if (!this.serverConfig.serverCertificate) {
      return null;
    }

    return Certificate.fromPEM(Buffer.from(this.serverConfig.serverCertificate, 'utf8'));
  }

  get clientCertificate(): Certificate | null {
    if (!this.serverConfig.clientCertificate) {
      return null;
    }

    return Certificate.fromPEM(Buffer.from(this.serverConfig.clientCertificate, 'utf8'));
  }

  private async onServerCertificateFileChanged(file: File) {
    if (!file) {
      return;
    }

    try {
      const fileContent = await FileStringReader.read(file);
      Certificate.fromPEM(Buffer.from(fileContent, 'utf8'));
      this.serverConfig.serverCertificate = fileContent;
    } catch (error) {
      Notify.Error(this.logger, `Could not load file`, error);
      this.serverCertificateFile = null;
    }
  }

  private clearClientCertificate() {
    this.serverConfig.clientCertificate = null;
    this.serverConfig.clientKey = '';
  }

  private async onClientCertificateFileChanged(file: File) {
    if (!file) {
      return;
    }

    try {
      const fileContent = await FileStringReader.read(file);
      Certificate.fromPEM(Buffer.from(fileContent, 'utf8'));
      this.serverConfig.clientCertificate = fileContent;
    } catch (error) {
      Notify.Error(this.logger, `Could not load file`, error);
      this.clientCertificateFile = null;
    }
  }

  private async onClientKeyFileChanged(file: File) {
    if (!file) {
      return;
    }

    try {
      this.serverConfig.clientKey = await FileStringReader.read(file);
    } catch (error) {
      Notify.Error(this.logger, 'Could not load file', error);
    }
  }

}

